<template>
  <v-container class="py-5">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card outlined>
          <v-card-title>
            <h2 class="text-h6">Ajouter un service</h2>
          </v-card-title>
          <v-form @submit.prevent="submitForm" ref="form">
            <v-card-text>
              <v-select
                v-model.number="form.canteen"
                :items="canteenOptions"
                item-text="name"
                item-value="id"
                label="Cantine"
                outlined
                dense
                required
                return-object="false"
              ></v-select>
              <v-text-field v-model="form.name" label="Nom du service" outlined dense required></v-text-field>
              <v-textarea v-model="form.comment" label="Commentaire" outlined dense></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" type="submit">Ajouter</v-btn>
              <router-link :to="{ name: 'ServiceList' }">
                <v-btn text>Annuler</v-btn>
              </router-link>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ServiceForm",
  data() {
    return {
      canteenOptions: [],
      form: {
        canteen: null,
        name: "",
        comment: "",
      },
    }
  },
  methods: {
    async fetchCanteens() {
      try {
        const response = await this.$store.dispatch("fetchCanteenSummary")
        // If response is paginated, use response.results
        this.canteenOptions = response.results || response
      } catch (e) {
        this.canteenOptions = []
      }
    },
    async submitForm() {
      try {
        const payload = {
          ...this.form,
          canteen: Number(this.form.canteen.id),
        }
        await this.$store.dispatch("createService", { payload })
        this.$router.push({ name: "ServiceList" })
      } catch (e) {
        // Optionally handle error (e.g., show notification)
      }
    },
  },
  mounted() {
    this.fetchCanteens()
  },
}
</script>
